import { Injectable } from '@angular/core';
import { Action, Store } from '@ngrx/store';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Observable, of } from 'rxjs';
import { catchError, filter, map, mergeMap, tap } from 'rxjs/operators';
import {
  loadTransactions,
  loadTransactionsFailure,
  loadTransactionsSuccess,
  reloadTransactions,
  toggleTransactionsLoading,
} from '../actions/transaction-history.actions';
import { PaypointService } from '../../services/paypoint.service';
import { LayoutUtility } from '../../../../shared/utils';
import { QueryParamsModel } from '../../../_base/crud';

@Injectable()
export class TransactionHistoryEffects {
  savedQuery: QueryParamsModel;

  constructor(
    private actions$: Actions,
    private store: Store,
    private layoutUtility: LayoutUtility,
    private paypointService: PaypointService,
  ) {}

  loadTransactions$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(loadTransactions),
        tap(() => {
          this.store.dispatch(toggleTransactionsLoading({ transactionsLoading: true }));
        }),
        mergeMap((action) => {
          this.savedQuery = action.query;
          return this.paypointService.getTransactions(action.query).pipe(
            map((res) => {
              return loadTransactionsSuccess({
                transactions: res?.data?.Transactions,
                totalTransactions: res?.data?.TotalTransactions,
                totalFailedTransactions: res?.data?.TotalFailedTransactions,
                successRate: res?.data?.SuccessRate,
                totalToday: res?.data?.TotalToday,
                totalThisWeek: res?.data?.TotalThisWeek,
                totalThisMonth: res?.data?.TotalThisMonth,
                monthOverMonthChange: res?.data?.MonthOverMonthChange,
              });
            }),
            catchError(() => {
              this.layoutUtility.showActionNotification('ERROR', 'Error: Something went wrong!');

              return of(loadTransactionsFailure());
            }),
          );
        }),
        tap(() => {
          this.store.dispatch(toggleTransactionsLoading({ transactionsLoading: false }));
        }),
      ) as Observable<Action>,
  );

  reloadTransactions$ = createEffect(() =>
    this.actions$.pipe(
      ofType(reloadTransactions),
      filter(() => !!this.savedQuery),
      map(() => loadTransactions({ query: this.savedQuery })),
    ),
  );
}
